export const setAcessos = (acessos) => ({
  type: "SET_ACESSOS",
  payload: acessos,
});

export const setAcessoAtivo = (acesso) => ({
  type: "SET_ACESSO_ATIVO",
  payload: acesso,
});

export const setPerfilAtivo = (perfil) => ({
  type: "SET_PERFIL_ATIVO",
  payload: perfil,
});
